(function () {
  var STORAGE_KEY = 'dm:favorites';
  var favoriteButtons = document.querySelectorAll('[data-product-favorite]');
  var shareButtons = document.querySelectorAll('[data-product-share]');

  if (!favoriteButtons.length && !shareButtons.length) {
    return;
  }

  function readFavorites() {
    try {
      var stored = window.localStorage.getItem(STORAGE_KEY);
      var parsed = stored ? JSON.parse(stored) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function writeFavorites(favorites) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
    } catch (error) {
      return false;
    }

    window.dispatchEvent(
      new CustomEvent('dm:favorites:change', {
        detail: {
          favorites: favorites,
        },
      })
    );

    return true;
  }

  function getProduct(button) {
    return {
      id: String(button.dataset.productId || ''),
      handle: button.dataset.productHandle || '',
      title: button.dataset.productTitle || '',
      url: button.dataset.productUrl || '',
      image: button.dataset.productImage || '',
      price: button.dataset.productPrice || '',
    };
  }

  function findFavoriteIndex(favorites, product) {
    return favorites.findIndex(function (favorite) {
      if (product.id && String(favorite.id) === product.id) {
        return true;
      }

      return product.handle && favorite.handle === product.handle;
    });
  }

  function setButtonState(button, isFavorite) {
    button.classList.toggle('is-active', isFavorite);
    button.setAttribute('aria-pressed', isFavorite ? 'true' : 'false');
    button.setAttribute('aria-label', isFavorite ? 'Eliminar de favoritos' : 'Agregar a favoritos');
  }

  function syncButton(button) {
    var favorites = readFavorites();
    var product = getProduct(button);
    setButtonState(button, findFavoriteIndex(favorites, product) > -1);
  }

  favoriteButtons.forEach(function (button) {
    syncButton(button);

    button.addEventListener('click', function (event) {
      event.preventDefault();

      var favorites = readFavorites();
      var product = getProduct(button);
      var favoriteIndex = findFavoriteIndex(favorites, product);
      var isFavorite = favoriteIndex > -1;

      if (isFavorite) {
        favorites.splice(favoriteIndex, 1);
      } else {
        favorites.push(product);
      }

      if (writeFavorites(favorites)) {
        setButtonState(button, !isFavorite);
      }
    });
  });

  window.addEventListener('storage', function (event) {
    if (event.key !== STORAGE_KEY) {
      return;
    }

    favoriteButtons.forEach(syncButton);
  });

  function showShareStatus(button, message) {
    var wrapper = button.closest('.product-media-actions');
    var status = wrapper ? wrapper.querySelector('[data-product-share-status]') : null;

    if (!status) {
      return;
    }

    window.clearTimeout(status.hideTimeout);
    status.textContent = message;
    status.classList.add('is-visible');

    status.hideTimeout = window.setTimeout(function () {
      status.classList.remove('is-visible');
    }, 1800);
  }

  function copyToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.top = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        document.execCommand('copy') ? resolve() : reject();
      } catch (error) {
        reject(error);
      } finally {
        document.body.removeChild(textarea);
      }
    });
  }

  shareButtons.forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();

      var shareData = {
        title: button.dataset.productShareTitle || document.title,
        text: button.dataset.productShareTitle || document.title,
        url: button.dataset.productShareUrl || window.location.href,
      };

      if (navigator.share) {
        navigator.share(shareData).catch(function () {});
        return;
      }

      copyToClipboard(shareData.url)
        .then(function () {
          showShareStatus(button, 'Enlace copiado');
        })
        .catch(function () {
          showShareStatus(button, 'No se pudo copiar');
        });
    });
  });
})();
